import { Loader } from "@partners/ui";
import { createFileRoute } from "@tanstack/react-router";

import { UnauthenticatedAppLayout } from "@/components/AppLayout";

export const Route = createFileRoute("/_unauthenticated")({
  component: UnauthenticatedAppLayout,
  pendingComponent: () => <Loader />,
});
